import { render, staticRenderFns } from "./sku-list2.vue?vue&type=template&id=6b6d5410&scoped=true"
import script from "./sku-list2.vue?vue&type=script&lang=ts"
export * from "./sku-list2.vue?vue&type=script&lang=ts"
import style0 from "./sku-list2.vue?vue&type=style&index=0&id=6b6d5410&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d5410",
  null
  
)

export default component.exports